// extracted by mini-css-extract-plugin
export default {"fileDropContainer":"style_fileDropContainer__U1y-w","dragText":"style_dragText__A4Mh5","browseText":"style_browseText__gn1pP","fileInput":"style_fileInput__PNcIf"};